import { VisitInstanceId } from "../../shared/schema/schema";
import { createQueryKeys } from "../../shared/utils/create-query-keys";

export const visitInstanceKeys = createQueryKeys("visit_instance", {
  get: (id: VisitInstanceId) => id,
  list: null,
  search: (searchTerm: string) => ({ searchTerm }),
});
